<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-col cols="12">
        <v-row v-if="account.role !== MANAGER_TOP">
          <v-col
            cols="12"
            style="text-align: center;"
          >У вас нет доступа к просмотру информации на этой странице
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="account.role === MANAGER_TOP">
        <v-row :key="orderType" v-for="(orderTypeText, orderType) in orderTypes">
          <v-col cols="12">
            <h4 class="pl-3">{{ orderTypeText }}</h4>
          </v-col>
          <v-col v-if="orderType !== 'office'" cols="12" md="6">
            <per-day-stats :text="$t('dashboard.stats_today')"
                           :days="0"
                           :order-type="orderType" region="kyiv_region_cf"/>
          </v-col>
          <v-col v-if="orderType !== 'office'" cols="12" md="6">
            <per-day-stats :order-type="orderType" region="kyiv_region_cf"/>
          </v-col>
          <v-col cols="12" md="6">
            <several-days-sparkline
              :order-type="orderType"
              method="latestDaysCreated"
              :text="$t('dashboard.created_orders')"
              region="kyiv_region_cf"
              hasRange
            />
          </v-col>
          <v-col v-if="['base'].includes(orderType)" cols="12" md="6">
            <several-days-sparkline
              :order-type="orderType"
              method="latestDaysCreatedSubscriptionOrders"
              :text="$t('dashboard.created_orders_sub')"
              region="kyiv_region_cf"
              hasRange
            />
          </v-col>
          <v-col cols="12" md="6">
            <several-days-sparkline
              :text="$t('dashboard.completed_orders')"
              method="latestDaysDone"
              :order-type="orderType"
              region="kyiv_region_cf"
              hasRange
            />
          </v-col>
          <v-col cols="12" md="6">
            <actual-orders :order-type="orderType" region="kyiv_region_cf"/>
          </v-col>
          <v-col v-if="orderType !== 'office'" cols="12" md="6">
            <several-days-ordered-stats :order-type="orderType" region="kyiv_region_cf"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="account.role === MANAGER_TOP">
        <v-row>
          <v-col cols="12">
            <h4 class="pl-3">{{$t('dashboard.ratings')}}</h4>
          </v-col>
          <v-col cols="12" md="6">
            <several-days-sparkline
              :order-type="'estimation'"
              method="latestDaysCreated"
              :text="$t('dashboard.created_ratings')"
              region="kyiv_region_cf"
            />
          </v-col>
          <v-col cols="12" md="6">
            <several-days-sparkline
              :text="$t('dashboard.closed_ratings')"
              method="latestDaysDone"
              :order-type="'estimation'"
              region="kyiv_region_cf"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
/* constants */
import { MANAGER_TOP } from '@/constants/roles';
/* components */
import SeveralDaysSparkline from '@/components/reports/SeveralDaysSparkline.vue';
import SeveralDaysOrderedStats from '@/components/reports/SeveralDaysOrderedStats.vue';
import ActualOrders from '@/components/reports/ActualOrders.vue';
import PerDayStats from '@/components/reports/PerDayStats.vue';

export default {
  name: 'KyivRegionCf',
  components: {
    SeveralDaysSparkline,
    ActualOrders,
    PerDayStats,
    SeveralDaysOrderedStats,
  },
  data() {
    return {
      MANAGER_TOP,
      orderTypes: {
        base: i18n.t('dashboard.orderTypes.base'),
        office: i18n.t('dashboard.orderTypes.office'),
        complex: i18n.t('dashboard.orderTypes.complex'),
        dry_cleaning: i18n.t('dashboard.orderTypes.dry_cleaning'),
        // office_b2b: i18n.t('dashboard.orderTypes.office_b2b'),
      },
    };
  },
  computed: {
    /* store */
    account() {
      return this.$store.getters['account/account'];
    },
  },
};
</script>
